import React from 'react';
import { Typography, Grid, Paper } from '@material-ui/core';
import { Section, SmSpace } from 'm2m.components';
import { CotasDeFundoApiResponse } from 'common/genericTypes';
import moment from 'moment';
import { addCpfCnpjMask } from 'utils/mask';
import { formatCurrencyNumber } from 'utils/number';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { documentShortDescriptions } from 'common/genericDescriptions';

interface Props {
  caracteristicas: CotasDeFundoApiResponse;
}

export const DetalhesCaracteristicas: React.FC<Props> = (props) => {
  const { caracteristicas } = props;
  const dispatch = useDispatch();
  const instrumentoApi = useSelector((state: RootState) => state.instrumentoApi);

  const handleDownload = async (documentId?: string) => {
    if (!documentId) return;
    const signedUrl = await instrumentoApi.getInstrumentoDocumentDownloadUrl(dispatch as any, documentId, true);
    if (!signedUrl) return;
    window.open(signedUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <Section title={'Informações Básicas do Fundo'} defaultGrid>
        <div>
          <Typography variant="body2">{'CNPJ do Fundo:'}</Typography>
          <Typography variant="body1">{addCpfCnpjMask(caracteristicas.cnpjFundo) || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Administrador Fiduciário:'}</Typography>
          <Typography variant="body1">{caracteristicas.administradorFiduciario || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Nome Fantasia:'}</Typography>
          <Typography variant="body1">{caracteristicas.nomeFantasia || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Gestor:'}</Typography>
          <Typography variant="body1">{caracteristicas.gestor || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Escriturador (Nome Simplificado):'}</Typography>
          <Typography variant="body1">{caracteristicas.escriturador || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Custodiante:'}</Typography>
          <Typography variant="body1">{caracteristicas.custodiante || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Código do Ativo:'}</Typography>
          <Typography variant="body1">{caracteristicas.codigo || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Classe:'}</Typography>
          <Typography variant="body1">{caracteristicas.classe || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Série:'}</Typography>
          <Typography variant="body1">{caracteristicas.numeroSerie || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Código ISIN:'}</Typography>
          <Typography variant="body1">{caracteristicas.isin || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Classificação ANBIMA:'}</Typography>
          <Typography variant="body1">{caracteristicas.classificacaoANBIMA || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Código ANBIMA:'}</Typography>
          <Typography variant="body1">{caracteristicas.codigoANBIMA || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Número de Autorização CVM:'}</Typography>
          <Typography variant="body1">{caracteristicas.numeroAutorizacaoCVM || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Data de Autorização CVM:'}</Typography>
          <Typography variant="body1">
            {caracteristicas.dataAutorizacaoCVM
              ? moment(caracteristicas.dataAutorizacaoCVM).format('DD/MM/YYYY')
              : '-'}
          </Typography>
          <SmSpace />
        </div>
      </Section>

      <Section title={'Características do Fundo'} defaultGrid>
        <div>
          <Typography variant="body2">{'Fundo Exclusivo:'}</Typography>
          <Typography variant="body1">{caracteristicas.fundoExclusivo ? 'SIM' : 'NÃO'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Carência (dias):'}</Typography>
          <Typography variant="body1">{caracteristicas.carencia || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Tipo de Fundo:'}</Typography>
          <Typography variant="body1">{caracteristicas.tipoFundo || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Casas Decimais para Conversão:'}</Typography>
          <Typography variant="body1">{caracteristicas.casasDecimaisConversao || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Critério de Especificação de Cotas:'}</Typography>
          <Typography variant="body1">{caracteristicas.criterioEspecificacaoCotas || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Especificação de Quantidade Automática:'}</Typography>
          <Typography variant="body1">{caracteristicas.especificacaoQuantidadeAutomatica ? 'SIM' : 'NÃO'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Custo de Cotista:'}</Typography>
          <Typography variant="body1">{caracteristicas.custoCotista || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Confirmação de Operação:'}</Typography>
          <Typography variant="body1">{caracteristicas.confirmacaoOperacao || '-'}</Typography>
          <SmSpace />
        </div>
      </Section>

      <Section title={'Prazos e Condições'} defaultGrid>
        <div>
          <Typography variant="body2">{'Prazo de Cotação de Aplicação (dias):'}</Typography>
          <Typography variant="body1">{caracteristicas.prazoCotacaoAplicacao || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Prazo de Cotização de Resgate (dias):'}</Typography>
          <Typography variant="body1">{caracteristicas.prazoCotacaoResgate || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Prazo de Liquidação de Resgate (dias):'}</Typography>
          <Typography variant="body1">{caracteristicas.prazoLiquidacaoResgate || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Responsável pela classificação do fundo:'}</Typography>
          <Typography variant="body1">{caracteristicas.responsavelClassificacaoFundo || '-'}</Typography>
          <SmSpace />
        </div>
        <div>
          <Typography variant="body2">{'Tem previsão de penalty?'}</Typography>
          <Typography variant="body1">{caracteristicas.temPrevisaoPenalty ? 'SIM' : 'NÃO'}</Typography>
          <SmSpace />
        </div>
        {caracteristicas.temPrevisaoPenalty && (
          <div>
            <Typography variant="body2">{'Percentual do penalty:'}</Typography>
            <Typography variant="body1">{caracteristicas.percentualPenalty || '-'}%</Typography>
            <SmSpace />
          </div>
        )}
        <div>
          <Typography variant="body2">{'Descrição do Fundo:'}</Typography>
          <Typography variant="body1">{caracteristicas.descricaoFundo || '-'}</Typography>
          <SmSpace />
        </div>
      </Section>
      {caracteristicas.documents && caracteristicas.documents.length > 0 && (
        <Section title={'Documentos'} defaultGrid>
          <div style={{ gridColumn: '1 / -1' }}>
            {caracteristicas.documents.map((doc) => (
              <div key={doc.id || doc.fileName}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <InsertDriveFileOutlinedIcon style={{ color: '#616161' }} fontSize="small" />
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => handleDownload(doc.id)}
                  >
                    {doc.fileName}
                  </Typography>
                </div>
                {doc.emissionType && documentShortDescriptions[doc.emissionType] && (
                  <Typography variant="caption" color="textSecondary" style={{ marginLeft: 24 }}>
                    {documentShortDescriptions[doc.emissionType]}
                  </Typography>
                )}
              </div>
            ))}
          </div>
        </Section>
      )}
      <SmSpace />
    </>
  );
};
